import { useEffect, useState } from "react";

// Styled confirm/notify to replace native window.confirm / window.alert across the portal.
// Promise-based imperative API so call sites read the same as the native ones:
//   if (!(await confirmDialog("Delete X?", { danger: true }))) return;
//   await notify("Saved.");
// If <ConfirmHost/> isn't mounted it FAILS CLOSED (a confirm answers no) instead of falling back to
// the browser's own box -- no browser pop-ups anywhere in Orator (2026-10-31, browser-popup-guard.py).
type Req = {
  message: string; danger?: boolean; confirmLabel?: string;
  kind: "confirm" | "notify"; resolve: (v: boolean) => void;
};
let enqueue: ((r: Req) => void) | null = null;

export function confirmDialog(message: string, opts?: { danger?: boolean; confirmLabel?: string }): Promise<boolean> {
  return new Promise((resolve) => {
    if (enqueue) enqueue({ message, danger: opts?.danger, confirmLabel: opts?.confirmLabel, kind: "confirm", resolve });
    else { console.error("confirmDialog: <ConfirmHost/> is not mounted"); resolve(false); }
  });
}
export function notify(message: string): Promise<void> {
  return new Promise((resolve) => {
    if (enqueue) enqueue({ message, kind: "notify", resolve: () => resolve() });
    else { console.error("notify: <ConfirmHost/> is not mounted", message); resolve(); }
  });
}

export function ConfirmHost() {
  const [queue, setQueue] = useState<Req[]>([]);
  useEffect(() => { enqueue = (r) => setQueue((p) => [...p, r]); return () => { enqueue = null; }; }, []);
  const cur = queue[0];
  if (!cur) return null;
  const close = (v: boolean) => { cur.resolve(v); setQueue((p) => p.slice(1)); };
  return (
    <div className="overlay above" onClick={() => close(cur.kind === "notify")}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 430 }}>
        <div className="body" style={{ padding: "20px 20px 8px", fontSize: 14, whiteSpace: "pre-wrap", lineHeight: 1.5 }}>{cur.message}</div>
        <div className="foot">
          {cur.kind === "confirm" && <button className="btn" onClick={() => close(false)}>Cancel</button>}
          <button className={"btn " + (cur.danger ? "warn" : "accent")} style={{ marginLeft: "auto" }} autoFocus
            onClick={() => close(true)}>{cur.confirmLabel || (cur.kind === "notify" ? "OK" : "Confirm")}</button>
        </div>
      </div>
    </div>
  );
}
